import * as React from 'react';
import './employeeSelectModal.scss';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { Buttons } from 'rcd-cpp-ui/ui/button/Buttons';
import { Cancel, Continue } from 'rcd-cpp-ui/ui/button';
import { ReferenceSearch } from '../ReferenceSearch/referenceSearch';
import { NodeType } from '../../enums/NodeType';
import { Metadata } from '../../types/Metadata';

type ESMProps = {
  selected: Metadata;
  onSelect: (v: Metadata) => void;
  onClose: () => void;
  onContinue: () => void;
  header: string;
  description: string;
};

export const EmployeeSelectModal = ({
  selected,
  onSelect,
  onClose,
  onContinue,
  header,
  description
}: ESMProps) => {
  return (
    <div>
      <Modal
        id="employeeSelectModal"
        header={header}
        onClose={onClose}
        footer={
          <Buttons>
            <Cancel onClick={onClose} />
            <Continue onClick={onContinue} />
          </Buttons>
        }
      >
        <span>{description}</span>
        <ReferenceSearch
          onChange={values => onSelect(values[0])}
          nodeType={NodeType.Employee}
          maxResults={50}
          minLength={0}
          selected={selected ? [selected] : null}
        />
      </Modal>
    </div>
  );
};
